/**
 * Base for any component. A component can be any element on the website, that provides some custom functionality. Use
 * the `ComponentRegistry` to register components globally, so that they may be accessed across different components.
 * This is best done at the end of a constructor within an actual component:
 *
 * ```ts
 * constructor() {
 *   // ...
 *   ComponentRegistry.add('some-id', this);
 * }
 * ```
 *
 * @author Philipp Seiler <sep@earlybird.at>
 * @see ComponentRegistry
 */
export class AbstractComponent<T extends any> {
  // Settings for the component
  private _settings: T;

  constructor() {
    this._settings = {} as T;
  }

  public get settings(): T {
    return this._settings;
  }

  public set settings(settings: T) {
    this._settings = settings;
  }

  public setSettingsFromElement(element: HTMLElement): void {
    if (element.dataset.settings) {
      this.settings = JSON.parse(element.dataset.settings);
    }
  }
}
